import { Component } from "react";

import { GetReadOnlyEmptyStateCreateMessage } from "utilities/emptyState/emptyStateUtility";
import { isInPortal } from "utilities/portal/portal";

import { BTButton } from "commonComponents/btWrappers/BTButton/BTButton";
import { BTCol } from "commonComponents/btWrappers/BTCol/BTCol";
import { BTIconBillsPurchaseOrders } from "commonComponents/btWrappers/BTIcon";
import { BTRow } from "commonComponents/btWrappers/BTRow/BTRow";
import BLALink from "commonComponents/entity/emptyState/common/BLALink";
import {
    EmptyStateDataType,
    emptyStateIconSize,
    type IEmptyStateEntityProps,
} from "commonComponents/entity/emptyState/common/EmptyState.api.types";
import { EmptyState, getEmptyStateDataType } from "commonComponents/entity/emptyState/EmptyState";
import { FilteredEmptyState } from "commonComponents/entity/emptyState/FilteredEmptyState";

export class BillEmptyState extends Component<IEmptyStateEntityProps> {
    private getEmptyStateContent = () => {
        const { onCallToActionClick, isReadonly, helpLink } = this.props;

        if (isInPortal({ subs: true, owner: true })) {
            return "No Bills available.";
        }

        if (isReadonly) {
            return GetReadOnlyEmptyStateCreateMessage("Bills");
        }

        return (
            <>
                <BTRow>
                    <BTCol xs={24}>{getBillEmptyStateDescription()}</BTCol>
                </BTRow>
                <BTRow gutter={8} className="margin-top-lg">
                    <BTCol>
                        <BLALink href={helpLink} />
                    </BTCol>
                    <BTCol className="text-center">
                        <BTButton
                            data-testid="BillCreate"
                            type="primary"
                            onClick={onCallToActionClick}
                        >
                            Add a Bill
                        </BTButton>
                    </BTCol>
                </BTRow>
            </>
        );
    };

    render() {
        const dataType = getEmptyStateDataType({ ...this.props, onCallToActionClick: () => {} });
        if (dataType === null) {
            return null;
        }

        if (dataType === EmptyStateDataType.FilteredState) {
            return <FilteredEmptyState entityTitlePlural="Bills" />;
        }

        return (
            <EmptyState
                title={getBillEmptyStateTitle()}
                image={
                    <BTIconBillsPurchaseOrders
                        size={emptyStateIconSize}
                        className="EmptyStateIcon"
                        data-testid="EmptyStateIcon"
                    />
                }
            >
                {this.getEmptyStateContent()}
            </EmptyState>
        );
    }
}

export function getBillEmptyStateTitle() {
    return "Never lose a payment with Bills";
}

export function getBillEmptyStateDescription() {
    return "Track expenses on the go and apply them against Purchase Orders to compare estimated versus actual costs.";
}
